export const useMobileDetector = () => {
    if (process.server) {
        const headers = useRequestHeaders(['user-agent']);
        const userAgent = headers['user-agent'];
        return /mobile/i.test(userAgent);
    } else {
        return /mobile/i.test(navigator.userAgent);
    }
};
